<!--
@Time : 2020/9/9 10:11 上午
@Author : yekong
@File : topnav.vue
@Software : PhpStorm
-->
<template>
  <div class="topnavx2">
    <div class="topnav">
      <div class="topnavx">
        <superslide v-if="show" :options="options" class="slideBox">
          <!-- slot="prev" -->
          <div class="qh"><a class="prev" href="javascript:void(0)" slot="prev">
            <img src="../../assets/lefticon.png" alt="">
          </a></div>
          <div class="bd">
            <ul>
              <li v-for="(item,index) in list" :key="index">
                <router-link :to="item.url" class="topnavxitem">
                  <p>{{ item.name }}</p>
                </router-link>
              </li>
            </ul>
          </div>
          <!-- slot="next" -->
          <div class="qh2"><a class="next" href="javascript:void(0)" slot="next">
            <img src="../../assets/righticon.png" alt="">
          </a></div>
        </superslide>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "topnav",
  data() {
    return {
      activeIndex: '',
      options: {
        "mainCell": ".bd ul",
        "autoPage": true,
        "effect": "left",
        "autoPlay": false,
        "vis": 6,
        "scroll": 1,
        "defaultIndex": -1,
        "trigger": "click",
        "pnLoop": "false"
      },
      show: false,
      list: [
        {
          name: '总览页',
          url: '/'
        }, {
          name: '办理建筑许可',
          url: '/banlijianzhuxuke'
        }, {
          name: '劳动力市场监控',
          url: '/laodonglishichangjiankong'
        }, {
          name: '获得信贷',
          url: '/huodexindai'
        }, {
          name: '办理破产',
          url: '/pochan'
        }, {
          name: '执行合同',
          url: '/zhixinghetong'
        }, {
          name: '政府采购',
          url: '/zhengfucaigou'
        }, {
          name: '纳税分析',
          url: '/nashui'
        }, {
          name: '保护中小投资者',
          url: '/baohuzhongxiaotouzizhe'
        }, {
          name: '登记财产',
          url: '/dengjicaichan'
        }, {
          name: '跨境贸易',
          url: '/kuajingmaoyi'
        }, {
          name: '获得电力',
          url: '/huodedianli'
        }, {
          name: '企业开办',
          url: '/qiyekaiban'
        }]
    };
  },
  props: {
    defaultIndex: {
      // 要显示的数组
      type: Number,
      default() {
        return -1;
      }
    }
  },
  watch: {
    defaultIndex() {
      this.options.defaultIndex = this.defaultIndex;
      this.$nextTick(function () {
        this.$forceUpdate();
        this.show = true
      })
    }
  },
  mounted() {
    this.options.defaultIndex = this.defaultIndex;
    this.$nextTick(function () {
      this.$forceUpdate();
      this.show = true
    })
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    geterjiactive(e) {
      this.listerjihover = e;
    },
    geterjiactive2(e) {
      this.sanjiid = e;
    },
  }
}
</script>


<style lang="scss" scoped>
.slideBox {
  position: relative;

  .bd {
    margin-left: 100px;
    margin-right: 100px;
    display: inline-block;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;

      a {
        display: block;
        height: 170px;
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        padding-top: 80px;

        p {
          font-size: 46px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
        }
      }

      a.router-link-exact-active {
        font-size: 46px;
        font-family: PingFang;
        font-weight: 800;
        color: #47D6FF;
        border-top: 10px solid rgba(71, 214, 255, 1);
        background: linear-gradient(to bottom, rgba(21, 138, 246, 1), #182552);

        p {
          color: #47D6FF;
          margin-top: -10px;
        }
      }
    }
  }
}

.qh {
  width: 58px;
  display: inline-block;
  height: 50px;
  position: absolute;
  left: 10px;
  top: 100px;
}

.qh2 {
  width: 58px;
  display: inline-block;
  height: 50px;
  position: absolute;
  right: 10px;
  top: 100px;
}

.topnavx2 {
  margin-right: 500px;
}
</style>
